import * as React from "react";
// import { pure } from 'recompose'
import * as noCache from "shortid";
import ImgFrom from "react-image";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { localUrl, name, classnames, id } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <ImgFrom
      loader={<div className="imageBrokenLoader" />}
      src={localUrl && localUrl + "?nocache=" + noCache.generate()}
      alt={name}
      className={classnames}
      id={id}
    />
  );
};

// interface
interface ComponentInterface {
  localUrl?: any;
  name?: string;
  classnames?: any;
  id?: string;
  key?: string;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/stream/component.tsx